import React from 'react';

import {Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {Close as CloseIcon} from '@mui/icons-material';

interface Props extends DialogProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

const DialogBase = ({title, onClose, children, ...props}: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Dialog fullWidth maxWidth="lg" onClose={onClose} {...props}>
      <DialogTitle sx={{zIndex: 1}}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{minHeight: '80vh'}}>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" sx={{backgroundColor: theme.palette.background.paper}}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(DialogBase);
